<div class="topHorizTopNavFixed">
  <br>
  <div class="row pt-4 pb5">
    <div class="col-md-2">
    </div>
    <div class="col-md-1">
      <a href="https://www.scalanthropy.com" target="_blank">
        <img src="assets/images/Scalanthropy_logo.png"  alt="Logo" width="225" height="90" class="display-2 d-inline-block align-text-top">
      </a>
    </div>
    <div class="col-md-1">
    </div>
    <div class="col-md-5">
      &nbsp;&nbsp;<app-st-breadcrumbs [crumbs]="this.breadCrumbs"></app-st-breadcrumbs>
    </div>
    <div class="col-md-2">
      <app-logged-in-page-base *ngIf="this.requiresSignOutButton"></app-logged-in-page-base>
    </div>
    <div class="col-md-1">
    </div>
    <app-fixed-horizontal-nav-bar-scroll *ngIf="this.hasElementTags" [idVal]="this.scrollNavBarId" [elementTags]="this.elementTags"
    ></app-fixed-horizontal-nav-bar-scroll>
    <br *ngIf="!this.hasElementTags">
  </div>
</div>
